import { AntennaLogo } from "./AntennaLogo";

export const Footer = () => (
  <footer className="border-t border-white/5 bg-[#05050A]">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-10 md:flex-row md:px-8">
      <div className="flex items-center gap-2">
        <AntennaLogo className="h-5 w-5" />
        <span className="font-display font-black tracking-tighter">
          NOVA<span className="text-[#8B5CF6]">STREAM</span>
        </span>
      </div>
      <p className="font-body text-sm text-slate-500">© 2026 NovaStream. Todos os direitos reservados.</p>
      <p className="font-mono-accent text-xs uppercase tracking-widest text-slate-600">Entretenimento sem limites</p>
    </div>
  </footer>
);
